"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3BaseWallet = void 0;
class Web3BaseWallet extends Array {
    constructor(accountProvider) {
        super();
        this._accountProvider = accountProvider;
    }
}
exports.Web3BaseWallet = Web3BaseWallet;
//# sourceMappingURL=web3_base_wallet.js.map